import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { createChatStore } from "./store.js";
import ChatBotApp from "./components/ChatBotApp.js";
import ReduxifyProvider from "./Provider.js";
const ChatBotAppWithStore = ({
  preloadedState = {},
  chatConfig = {},
  parcelNumber,
  parcelCode,
  orderId,
  postCode,
  ...props
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const finalPreloadedState = parcelNumber ? {
    ...preloadedState,
    chat: {
      ...preloadedState.chat,
      config: {
        ...(_a = preloadedState.chat) == null ? void 0 : _a.config,
        parcelNumber,
        businessUnit: chatConfig.chatbot.businessUnit
      }
    }
  } : preloadedState;
  const store = createChatStore(finalPreloadedState);
  return /* @__PURE__ */ jsx(Provider, { store, children: /* @__PURE__ */ jsx(
    ReduxifyProvider,
    {
      chatBotHost: (_b = chatConfig.chatbot) == null ? void 0 : _b.host,
      dpdSession: (_c = chatConfig.chatbot) == null ? void 0 : _c.session,
      client: (_d = chatConfig.chatbot) == null ? void 0 : _d.client,
      salesforce: (_e = chatConfig.liveagent) == null ? void 0 : _e.host,
      organizationId: (_f = chatConfig.liveagent) == null ? void 0 : _f.organizationId,
      eliteDeploymentId: (_g = chatConfig.liveagent) == null ? void 0 : _g.eliteDeploymentId,
      platinumDeploymentId: (_h = chatConfig.liveagent) == null ? void 0 : _h.platinumDeploymentId,
      eliteButtonId: (_i = chatConfig.liveagent) == null ? void 0 : _i.eliteButtonId,
      platinumButtonId: (_j = chatConfig.liveagent) == null ? void 0 : _j.platinumButtonId,
      apiVersion: (_k = chatConfig.liveagent) == null ? void 0 : _k.apiVersion,
      googleMapsApiKey: chatConfig.googleMapsApiKey,
      children: /* @__PURE__ */ jsx(
        ChatBotApp,
        {
          parcelNumber,
          parcelCode,
          orderId,
          postCode,
          ...props
        }
      )
    }
  ) });
};
ChatBotAppWithStore.propTypes = {
  preloadedState: PropTypes.object,
  chatConfig: PropTypes.object,
  parcelNumber: PropTypes.string,
  parcelCode: PropTypes.string,
  orderId: PropTypes.string,
  postCode: PropTypes.string
};
export {
  ChatBotAppWithStore as default
};
//# sourceMappingURL=ChatBotAppWithStore.js.map
